<template>
  <v-container>
    <Modal
      @save="guardar"
      @close="close"
      :object="objEdit"
      :update="update"
      :show="abrirModal"
    />
    <template>
      <v-row>
        <v-col cols="12" md="4">
          <span class="align-center">
            Usuarios
          </span>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="value"
            :items="itemsFiltro"
            outlined
            dense
            label="Filtrar por..."
            @change="selectFiltro()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
            <v-btn color="primary" dark class="mb-2" v-on="on" @click="nuevo">Nuevo</v-btn>
        </v-col>
      </v-row>
    </template>
    <Table
      @edit="handleClick"
      :headers="headers"
      :arrayList="usuarios"
      :opciones="true"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Table from "@/components/base/Table.vue";
import Modal from "@/components/base/modal/ModalUsuario.vue";
import Headers from "../headers"

export default {
  data() {
    return {
      headers: Headers.headersUsuarios,
      itemsFiltro: [],
      values: [],
      value: null,
      modoChart: "column",
      abrirModal: false,
      objEdit: {},
      update: false,
    };
  },
  components: {
    Table,
    Modal,
  },
  filters: {
    conDeuda: (clientes) => clientes.filter((c) => c.deuda > 0),
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuarios"]),
  },
  methods: {
    ...mapActions("usuarioNamespace", ["getUsuarios", "saveUsuario"]),
    // llamarUsuarios() {
    //   let Token = this.token;
    //   this.getUsuarios(Token);
    // },
    handleClick(obj) {
      debugger;
      this.update = true,
      this.objEdit = obj;
      this.abrirModal = true;
    },
    nuevo() {
      this.abrirModal = true;
    },
    guardar(obj) {
      debugger;
      this.saveUsuario(obj);
      this.close();
      this.getUsuarios();
    },
    close() {
      this.abrirModal = false;
    },
  },
};
</script>
